import LoadingComponent from '../LoadingComponent';

import { StyledLoading } from './StyledComponents';

export const Loading = () => {
  return (
    <StyledLoading>
      <LoadingComponent />
    </StyledLoading>
  );
};
